export const getLocalStorage = (name: string): string => localStorage.getItem(name) || '';
